import React from "react";
import Concert from "../Components/Concert/Concert";
import ContactUs from "../Components/ContactUs/ContactUs";
import EffortlessBooking from "../Components/EffortlessBooking/EffortlessBooking";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import PricePlan from "../Components/PricePlan/PricePlan";
import SliderTestimonial from "../Components/SliderTestimonials/SliderTestimonial";
import TaxiServiceAccross from "../Components/TaxiServiceAccross/TaxiServiceAccross";
import TopNavbar from "../Components/TopNavbar/TopNavbar";
import WhyChooseKarline from "../Components/WhyChooseKarline/WhyChooseKarline";

const LandingPage = () => {
  return (
    <>
    <div className="topLandingPage">
      {/* <TopNavbar /> */}
      <Header />
      <TaxiServiceAccross />
      <PricePlan />
      <EffortlessBooking />

      <WhyChooseKarline />

      {/* <Concert />

      <SliderTestimonial /> */}

      <ContactUs />
      <Footer />
      </div>
    </>
  );
};

export default LandingPage;
